/* src/app/modules/login/login-otp/login-otp.component.scss */
ion-button {
  --background: #e35655 !important;
  text-transform: initial;
  border-radius: 0px;
}
.submit-button {
  color: white;
}
form {
  text-align: end;
  margin-top: 10px;
}
mat-divider {
  border-top-color: black !important;
  border-top-width: 1.5px;
}
.divider-top {
  padding-top: 14px;
}
/*# sourceMappingURL=login-otp.component.css.map */
